import { stringToSha256 } from '@marketplace-web/crypto/crypto-util'

export function encryptEmail(email: string) {
  return stringToSha256(email.trim().toLowerCase())
}
